<div class="asset-card" [class.asset-card--challenge]="variant === 'challenge'" [class.asset-card--preview]="previewMode" (click)="navigateToDetail()" [style.cursor]="previewMode ? 'default' : (assetType === 'dataset' || assetType === 'model' ? 'pointer' : 'default')">
  <!-- Challenge variant: exact replica of collection card layout -->
  <ng-container *ngIf="variant === 'challenge'">
    <div class="asset-card--content">
      <h3 class="asset-card--title asset-card--title-challenge">{{ data.title }}</h3>
      <div class="asset-card--provider-challenge" *ngIf="data.isNew || data.provider || data.organisation">
        <span>{{ data.isNew ? 'new' : (data.provider || data.organisation) }}</span>
      </div>
      <div class="asset-card--tag-pill" *ngIf="data.tags && data.tags.length > 0">
        <span>{{ getDisplayTag(data.tags[0]) }}</span>
      </div>
      <div class="asset-card--meta-row">
        <span class="asset-card--meta-format" *ngIf="data.metadata?.format">
          <svg class="asset-card--meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ data.metadata?.format }}</span>
        </span>
        <span class="asset-card--meta-dot" *ngIf="data.metadata?.format && data.metadata?.date">•</span>
        <span class="asset-card--meta-date" *ngIf="data.metadata?.date">
          <svg class="asset-card--meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>{{ data.metadata?.date }}</span>
        </span>
        <div class="asset-card--badge-inline" *ngIf="data.badge" [ngClass]="'asset-card--badge-' + (data.badge.color || 'public')">
          <svg class="asset-card--badge-inline-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>{{ data.badge.label }}</span>
        </div>
      </div>
      <div class="asset-card--divider"></div>
      <div class="asset-card--metrics">
        <span class="asset-card--metric">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
          <span>{{ data.likes ?? 0 }}</span>
        </span>
        <span class="asset-card--metric">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <span>{{ data.views ?? 0 }}</span>
        </span>
        <span class="asset-card--metric">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          <span>{{ data.downloads ?? 0 }}</span>
        </span>
        <button class="asset-card--arrow" aria-label="View details" (click)="navigateToDetail(); $event.stopPropagation()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Default variant -->
  <div class="asset-card--content" *ngIf="variant !== 'challenge'">
    <!-- Title -->
    <h3 class="asset-card--title">{{ data.title }}</h3>

    <!-- Provider/Organisation -->
    <div class="asset-card--provider" *ngIf="data.provider || data.organisation">
      <svg class="asset-card--provider-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M3 21H21M5 21V7L12 3L19 7V21M9 9V17M15 9V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ data.provider || data.organisation }}</span>
    </div>

    <!-- Description (for usecases) -->
    <p class="asset-card--description" *ngIf="data.description && assetType === 'usecase'">
      {{ data.description }}
    </p>

    <!-- Tags -->
    <div class="asset-card--tags" *ngIf="data.tags && data.tags.length > 0">
      <span class="asset-card--tag" *ngFor="let tag of data.tags">{{ getDisplayTag(tag) }}</span>
    </div>

    <!-- Metadata Row -->
    <div class="asset-card--metadata" *ngIf="data.metadata">
      <div class="asset-card--metadata-item" *ngIf="data.metadata.type">
        <span class="asset-card--metadata-label">{{ data.metadata.type }}</span>
      </div>
      <div class="asset-card--metadata-item" *ngIf="data.metadata.format">
        <span class="asset-card--metadata-label">{{ data.metadata.format }}</span>
      </div>
      <div class="asset-card--metadata-item" *ngIf="data.metadata.language">
        <svg class="asset-card--metadata-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M8 9L12 5L16 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 15L12 19L16 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ data.metadata.language }}</span>
      </div>
      <div class="asset-card--metadata-item" *ngIf="data.metadata.modelType">
        <svg class="asset-card--metadata-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ data.metadata.modelType }}</span>
      </div>
      <div class="asset-card--metadata-item" *ngIf="data.metadata.percentage">
        <img src="/shield-check.svg" alt="Shield" class="asset-card--metadata-icon" />
        <span>{{ data.metadata.percentage }}%</span>
      </div>
      <div class="asset-card--metadata-item" *ngIf="data.metadata.date">
        <svg class="asset-card--metadata-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
          <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>{{ data.metadata.date }}</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="asset-card--footer">
      <div class="asset-card--badge" *ngIf="data.badge" [ngClass]="'asset-card--badge-' + (data.badge.color || 'public')">
        <img src="/public.svg" alt="Public" class="asset-card--badge-icon" *ngIf="data.badge.color === 'public'"/>
        <img src="/public.svg" alt="Restricted" class="asset-card--badge-icon" *ngIf="data.badge.color === 'restricted'"/>
        <span>{{ data.badge.label }}</span>
      </div>
      <button class="asset-card--arrow" aria-label="View details" (click)="navigateToDetail(); $event.stopPropagation()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</div>

